export {AdminOrdersPage} from './orders-page';
